module.exports = __webpack_public_path__ + "static/img/about_h5bg_05_zh.5786c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_05_zh.png
// module id = oD7y
// module chunks = 34